export default __webpack_public_path__ + "static/media/gazebo.c92ffc39.png";